import { Button } from '@/UIComponents2/Button'
import { cn } from '@/utlis/cn'
import { DropdownMenu } from 'radix-ui'
import { useI18nLanguageActions } from '@/functionalities/Internationalization/useI18nLanguageActions'
import languageCodeNativeRepresentation from '../locales/languageCodeNativeRepresentation.json'
import * as Constants from '@/services/Constants'
import i18n from '@/i18n'
import { useContext, useState } from 'react'
import { PortalContext } from '@/UIComponents2/PortalContext'
import '@/components/dropdown-animation.css'

type LanguagesPopoverProps = {
    children?: React.ReactNode
    className?: string
}

export const LanguagesPopover = (props: LanguagesPopoverProps) => {
    const { setPreferredLanguage } = useI18nLanguageActions()
    const portalContainer = useContext(PortalContext)

    const [currentLanguage, setCurrentLanguage] = useState(i18n.language)

    const onSetPreferredLanguage = (code: string) => {
        setPreferredLanguage(code)
        setCurrentLanguage(code)
    }

    const style = 'w-[200px] py-4 bg-white/5 z-30'
    const border = 'border-1 border-white/10 rounded-[20px]'
    const bg = 'bg-[#3A3A3A]'
    return (
        <DropdownMenu.Root modal={false}>
            <DropdownMenu.Trigger asChild>{props.children}</DropdownMenu.Trigger>

            <DropdownMenu.Portal container={portalContainer}>
                <DropdownMenu.Content
                    className={cn('dropdown-menu-content', style, border, bg, props.className)}
                    sideOffset={5}
                >
                    <div className="flex flex-col max-h-[70vh]">
                        {Constants.availableLanguages.map((code) => {
                            const selected = currentLanguage === code
                            const nativeRepresentation = (languageCodeNativeRepresentation as any)[code] || ''
                            return (
                                <DropdownMenu.Item asChild key={code}>
                                    <Button
                                        className={cn(
                                            'hover:bg-white/10 px-4 py-2 text-left',
                                            selected ? 'font-medium' : 'text-muse-fg/80'
                                        )}
                                        onClick={() => {
                                            onSetPreferredLanguage(code)
                                        }}
                                    >
                                        <div className="flex items-center gap-1">
                                            <span className="w-[2ch]">{selected && '\u2713'}</span>{' '}
                                            {nativeRepresentation} ({code})
                                        </div>
                                    </Button>
                                </DropdownMenu.Item>
                            )
                        })}
                    </div>
                </DropdownMenu.Content>
            </DropdownMenu.Portal>
        </DropdownMenu.Root>
    )
}
